import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import WebViewer from '@pdftron/webviewer';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { 
  ArrowLeftIcon, 
  DocumentArrowUpIcon, 
  DocumentTextIcon,
  FolderIcon,
  PencilIcon,
  DocumentArrowDownIcon,
  TrashIcon,
  PlusIcon
} from '@heroicons/react/24/outline';

const DocxEditor = () => {
  const viewer = useRef(null);

  useEffect(() => {
    WebViewer(
      {
        path: '/lib/webviewer',
        licenseKey: 'YOUR_LICENSE_KEY',
        initialDoc: 'https://apryse.s3.amazonaws.com/public/files/samples/WebviewerDemoDoc.pdf',
      },
      viewer.current,
    ).then((instance) => {
        const { documentViewer } = instance.Core;
        // you can now call WebViewer APIs here...
      });
  }, []);

  return (
    <div className="MyComponent">
      <div className="header">React sample</div>
      <div className="webviewer" ref={viewer} style={{height: "100vh"}}></div>
    </div>
  );
};

export default DocxEditor; 